import superConfigRaw from '@public/superconfig.json';

/** Host key in superconfig.json for beta (used by review apps on *.preview.ksec.cl). */
const BETA_SUPERCONFIG_KEY = 'beta.ksec.cl';

const REVIEW_APP_HOST_REGEX = /^pr-\d+\.preview\.ksec\.cl$/;

function isLocalEnvironment(hostname: string): boolean {
  if (import.meta.env.DEV) {
    return true;
  }
  return (
    hostname === 'localhost'
    || hostname === '127.0.0.1'
    || hostname === '[::1]'
  );
}

function isReviewAppHost(hostname: string): boolean {
  return REVIEW_APP_HOST_REGEX.test(hostname);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ENV: any = {};

function assignLocalEnvFromVite(): void {
  Object.keys(import.meta.env).forEach((key) => {
    if (key.startsWith('VITE_')) {
      ENV[key] = import.meta.env[key as keyof ImportMetaEnv];
    }
  });
}

function initEnvConfig(): void {
  const superConfig = superConfigRaw as Record<string, Record<string, unknown>>;
  const { hostname } = window.location;

  if (isLocalEnvironment(hostname)) {
    assignLocalEnvFromVite();
    return;
  }

  let configForHost = superConfig[hostname];
  if (!configForHost && isReviewAppHost(hostname)) {
    configForHost = superConfig[BETA_SUPERCONFIG_KEY];
  }

  if (configForHost) {
    Object.assign(ENV, configForHost);
  } else {
    // eslint-disable-next-line no-console
    console.error(`No configuration found for host: ${hostname}`);
  }
}

// Execute synchronously immediately upon import
initEnvConfig();

// Keep async signature for backward compatibility with app.tsx mount logic
export const loadEnvConfiguration = async () => Promise.resolve();
